import { Button, ButtonProps } from '@mis/sushi-tailwind-react';
import classNames from 'classnames';
import React from 'react';

export const RedButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      type="button"
      data-testid="btnRed"
      {...props}
      className={classNames('bg-linear-to-t from-[#D9598A] to-[#C60650] text-white', props.className)}
    />
  );
};
